import * as manualApiClientConfigs from './config/index.js';
import { getClients } from './get-clients.js';

/**
 * Check that the given environment is valid.
 */
const validateEnvironment = environment => {
  const env = environment.toLowerCase();
  const validEnvironments = ['staging', 'preproduction', 'production'];
  if (validEnvironments.indexOf(env) < 0) {
    throw new TypeError(`Unknown environment: must be one of ${validEnvironments.join(', ')}, got "${env}"`);
  }
};

/**
 * Get the base URL for the set environment.
 */
const getBaseUrl = (apiName, env, baseURLs = {}) => {
  const apiClients = getClients();
  const configs = Object.entries(apiClients).reduce((acc, [name, {
    config
  }]) => ({
    ...acc,
    [name]: config
  }), {});
  if (!(apiName in manualApiClientConfigs) && !(apiName in configs)) {
    throw new TypeError(`Could not find a config file for API with name "${apiName}"`);
  }
  const {
    environments = {},
    settings: {
      corsEnabled = false
    } = {}
  } = configs[apiName] || manualApiClientConfigs[apiName] || {};
  validateEnvironment(env);
  const baseURL = corsEnabled ? environments[env] : baseURLs[apiName] || environments[env];
  if (!baseURL) {
    throw new Error(`No base URL could be found for the "${apiName}" "${env}" environment`);
  }
  return baseURL;
};

/**
 * Get a map of baseURLs against api clients for the set environment.
 */
export const getBaseUrls = (env, baseURLs = {}) => {
  const allClientKeys = [...Object.keys(manualApiClientConfigs), ...Object.keys(getClients())];
  return allClientKeys.reduce((acc, apiName) => {
    const baseUrl = getBaseUrl(apiName, env, baseURLs);
    acc[apiName] = baseUrl;
    return acc;
  }, {});
};
export default getBaseUrl;